export default [
  { id: 1, name: 'Facebook' },
  { id: 2, name: 'Instagram' },
  { id: 3, name: 'Linkedin' },
  { id: 4, name: 'Twitter' },
  { id: 5, name: 'Youtube' },
  { id: 6, name: 'TikTok' },
];
